<div
  class="modal-dialog"
  style=" display: table; width: auto"
>
  <div class="modal-content">
    <div class="modal-body">
      <h3 id="head-modal" class="head-modal">Remove Collaborators</h3>
      <p>Do you wish to proceed?</p>
      <div class="modal-footer">
        <button
          (click)="submit()"
          id="btn-remove-collaborate"
          type="submit"
          class="btn btn-default gernal-btn"
          data-dismiss="modal"
        >
          Yes
        </button>
        <button
          (click)="cancel()"
          type="button"
          class="btn btn-default gernal-btn"
          data-dismiss="modal"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
